import { render, staticRenderFns } from "./WishListBtn.vue?vue&type=template&id=50533b72&scoped=true&"
import script from "./WishListBtn.vue?vue&type=script&lang=js&"
export * from "./WishListBtn.vue?vue&type=script&lang=js&"
import style0 from "./WishListBtn.vue?vue&type=style&index=0&id=50533b72&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50533b72",
  null
  
)

export default component.exports